import { useQuery } from 'react-query';

import { getTrapActivationHistory } from 'api/traps/Trap/getTrapActivationHistory';

export const useGetTrapActivationHistory = (slug: string, type: string, startDate?: string, endDate?: string) => {
  const { data, refetch, isLoading } = useQuery(
    ['GetTrapActivationHistory', slug, type, startDate, endDate],
    () => getTrapActivationHistory(slug, type, startDate, endDate),
    {
      refetchOnWindowFocus: false,
      refetchInterval: 10000,
    },
  );

  return { data, refetch, isLoading };
};

export default useGetTrapActivationHistory;
